// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"413":"b572b775","796":"036fbb3a","963":"18d98ad3"}[chunkId] + ".chunk.js";
};